module.exports = __webpack_public_path__ + "img/dracs-lullaby.5b646824.jpg";